module.exports = __webpack_public_path__ + "static/grandprize-bg-ffe5c21c8d9bc37c22b9cbb4e456775f.jpg";